var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("岗位支援接收-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "60px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("\n\t\t\t\t\t\t支援项目：\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$parent.ruleForm.project_name) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("\n\t\t\t\t\t\t开始时间：\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$parent.ruleForm.start_date) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("\n\t\t\t\t\t\t结束时间：\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$parent.ruleForm.end_date) + "\n\t\t\t\t")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0 100px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.$parent.support_staff_List
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "label": "姓名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_card",
      "label": "身份证号",
      "width": "300px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_telephone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "daily_wage",
      "label": "日工资",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "support_duration",
      "label": "时长",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.state))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state === '1') ? _c('el-button', {
          staticStyle: {
            "background-color": "#006E4B",
            "border-color": "#006E4B"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.xiugai(scope.row)
            }
          }
        }, [_vm._v("修改\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.state === '0') ? _c('el-button', {
          staticStyle: {
            "background-color": "#006E4B",
            "border-color": "#006E4B"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.operation(scope.row.staff_id, '0')
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t接收\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.state === '0') ? _c('el-button', {
          staticStyle: {
            "background-color": "#006E4B",
            "border-color": "#006E4B"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.operation(scope.row.staff_id, '1')
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t退回\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.state === '1') ? _c('el-button', {
          staticStyle: {
            "background-color": "#006E4B",
            "border-color": "#006E4B"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.end(scope.row)
            }
          }
        }, [_vm._v("完成\n\t\t\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0 100px",
      "margin-top": "40px",
      "text-align": "center"
    }
  }, [(_vm.$parent.ruleForm.support_type === '0') ? _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.operation(null, '2')
      }
    }
  }, [_vm._v("接收\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$parent.ruleForm.support_type === '0') ? _c('el-button', {
    staticStyle: {
      "background-color": "#FFFFFF",
      "border-color": "#006E4B",
      "color": "#006E4B",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.operation(null, '3')
      }
    }
  }, [_vm._v("退回\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$parent.ruleForm.support_type != '0') ? _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.End()
      }
    }
  }, [_vm._v("完成\n\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "退回原因",
      "visible": _vm.dialogVisible,
      "width": "35%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 7
    },
    model: {
      value: (_vm.return_reason),
      callback: function($$v) {
        _vm.return_reason = $$v
      },
      expression: "return_reason"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "30px",
      "padding-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B",
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.operation(null, '3')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改",
      "visible": _vm.dialogVisibles,
      "width": "30%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "8%"
    }
  }, [_vm._v("日工资：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请输入日工资"
    },
    model: {
      value: (_vm.form.daily_wage),
      callback: function($$v) {
        _vm.$set(_vm.form, "daily_wage", $$v)
      },
      expression: "form.daily_wage"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "30px",
      "padding-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B",
      "margin-left": "42%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "岗位支援结束",
      "visible": _vm.dialogVisiblejs,
      "width": "30%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblejs = $event
      }
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "8%"
    }
  }, [_vm._v("奖励：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入奖励"
    },
    model: {
      value: (_vm.form.reward),
      callback: function($$v) {
        _vm.$set(_vm.form, "reward", $$v)
      },
      expression: "form.reward"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "8%"
    }
  }, [_vm._v("惩罚：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入惩罚"
    },
    model: {
      value: (_vm.form.punishment),
      callback: function($$v) {
        _vm.$set(_vm.form, "punishment", $$v)
      },
      expression: "form.punishment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "30px",
      "padding-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B",
      "margin-left": "48%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.endjs()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "岗位支援结束",
      "visible": _vm.dialogVisiblejsall,
      "width": "30%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblejsall = $event
      }
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "8%"
    }
  }, [_vm._v("奖励：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入奖励"
    },
    model: {
      value: (_vm.form.reward),
      callback: function($$v) {
        _vm.$set(_vm.form, "reward", $$v)
      },
      expression: "form.reward"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "8%"
    }
  }, [_vm._v("惩罚：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入惩罚"
    },
    model: {
      value: (_vm.form.punishment),
      callback: function($$v) {
        _vm.$set(_vm.form, "punishment", $$v)
      },
      expression: "form.punishment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "30px",
      "padding-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border-color": "#006E4B",
      "margin-left": "48%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.Endjs()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shang"
  }, [_c('h4', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("支援人")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-898e389c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Gwzygl/Gwzyjs/Gwzyjs_edit.vue
// module id = null
// module chunks = 